import { IonIcon } from '@ionic/react';
import tablesClient from '../../logic/tables';
import { checkmarkOutline, close } from 'ionicons/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import forms from '../../utils/forms';
import CustomerAdder from './CustomerAdder';
import { useRestaurant } from '../../utils/contexts/restaurant-context';
import { useParams } from 'react-router';

export default function TableForm(props) {
    const { form, setForm, checkTables, setCheckTables } = props;

    const [errors, setErrors] = React.useState({});

    const { restaurant } = useRestaurant();
    const { t } = useTranslation();
    const { id, type } = useParams();

    const validators = {
        "number": forms.list(
            forms.required("Number is required"),
            forms.match(/^[a-zA-Z0-9 ]{0,6}$/, "Only numbers and letters are allowed; max 6 characters"),
        ),
    };

    const submitHandler = evt => {
        evt.preventDefault();

        let errors = forms.validateMany(validators, form);
        if (forms.anyErrors(errors)) {
            setErrors(errors);
        } else {
            setForm(form);
        }
    };

    const blurHandler = async ({ target }) => {
        const result = forms.validateMany(validators, { [target.name]: target.value });
        setErrors({ ...errors, ...result });
        const aux = target.value.replace(/[ ]/g, "").replace(/([a-zA-Z]+)/, "$1 ");
        let isActiveTable = await tablesClient.doGet(restaurant.token, aux);
        isActiveTable = isActiveTable.opened;

        if (forms.parseTable(aux, restaurant.orders.tableservice.tables_name) && isActiveTable) {
            setCheckTables(true);
            setForm(form => ({
                ...form,
                [target.name]: aux,
            }));
        } else {
            setCheckTables(false);
        }
    };

    const renderTableError = fieldName => {
        if (undefined !== errors[fieldName]) {
            return (
                <p className="error text-sm text-mycia-red">{errors[fieldName]}</p>
            );
        }
    };

    function renderText() {
        if (type === "h") {
            return <label htmlFor="number">{t("roomform.label_1")}</label>
        } if (type === "s") {
            return <label htmlFor="number">{t("bathhouseservice.label_1")}</label>
        }

        return <label htmlFor="number">{t("tableform.label_1")} </label>
    }

    return (
        <form name="table-form" id="table-form" className="table-form mt-6 text-center" onSubmit={submitHandler}>
            <div>
                <div className="flex justify-center items-center space-x-4">
                    <svg className="w-6 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 746.12 693.91">
                        <g data-name="Livello 2"><path d="M728.61 213.13a84.73 84.73 0 008.26 13.22 37.45 37.45 0 016.61 13.22 113.37 113.37 0 012.48 14 32.61 32.61 0 01-2.48 15.69 18.81 18.81 0 01-1.65 13.22c-2.22 4.42-4.13 8.55-5.79 12.39a47.56 47.56 0 01-8.26 12.39c-3.87 4.42-7.43 8.27-10.74 11.57L566.7 469.22l-34.7-34.7 148.7-150.35c3.3-2.19 5.5-4.38 6.61-6.6a21.6 21.6 0 014.13-5.79 7.89 7.89 0 002.47-5.78 5.3 5.3 0 013.31-5c-1.11-1.08-1.39-2.19-.83-3.3s.26-2.19-.82-3.3a4.71 4.71 0 01-1.66-3.31c0-1.08-1.11-2.19-3.3-3.3l-19.83-21.48-434.52 432.91-145.39 16.52-6.61-5-23.13 23.17L0 684l49.57-49.56-6.61-5 18.17-147L508.87 33a169.19 169.19 0 0014-12.39 87.18 87.18 0 0113.26-10.7 69.8 69.8 0 0114-7.43C554.56.83 560.09 0 566.7 0a52.27 52.27 0 018.3.83 30.65 30.65 0 018.26 2.47 86.16 86.16 0 018.26 5q4.95 3.33 6.61 6.61l89.22 87.56c2.19 3.31 5 7.18 8.26 11.57A49.47 49.47 0 01703 128a153.46 153.46 0 014.13 14.87 38.07 38.07 0 010 15.7 27.57 27.57 0 01-.82 6.61 30 30 0 00-.83 7.43 12.09 12.09 0 01-2.48 7.44 11.05 11.05 0 00-2.48 6.61L727 213.13zM213.13 611.31L494 332.09 386.61 226.35 109 505.57 95.83 611.31 109 622.87zM528.7 295.74l118.95-117.3c0-2.2 1.09-4.14 3.31-5.79s3.3-3.3 3.3-5a13.25 13.25 0 011.65-5.79 14.73 14.73 0 001.66-6.61c1.08-1.08 1.08-2.47 0-4.13s-1.4-3-.83-4.13 0-2.73-1.65-4.95-2.48-3.85-2.48-5l-89.22-85.82c1.09 0 .54.56-1.65 1.65a12.37 12.37 0 00-5 4.13 28.47 28.47 0 01-5.74 5.78c-2.76 2.22-4.13 3.87-4.13 5L423 190l107.35 105.74z" data-name="Livello 1" /></g>
                    </svg>
                    {renderText()}
                    {checkTables ? <IonIcon icon={checkmarkOutline} className="w-6 h-6 ml-2" color="success"></IonIcon> : <IonIcon icon={close} className="w-6 h-6" color="danger"></IonIcon>}
                </div>

                <input type="text" name="number" className="w-full mt-2 p-2 rounded-lg bg-grey-200" placeholder="123" onBlur={blurHandler} />

                <div className="flex items-center py-2">
                    {renderTableError("number")}
                </div>
            </div>

            <span className="flex border"></span>

            {id !== "HWwJ4J1Q0" &&
                <div>
                    <div className="flex justify-center items-center py-4">
                        <svg className="w-6 mr-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 690 691.35">
                            <g data-name="Livello 2"><path d="M668.44 591.62q-20.22-37.71-55.26-67.38T530.3 473q-47.85-21.54-104.44-29.65v-57.92a74.18 74.18 0 0013.48-14.82q6.72-9.42 12.12-18.87a140.08 140.08 0 009.44-20.22 198.49 198.49 0 018.1-18.86c3.58-2.7 6.95-5.16 10.11-7.42a35.53 35.53 0 008.76-9.43q4-6.06 7.41-11.45a59.47 59.47 0 006.07-14.83 134.3 134.3 0 004-20.21 61.85 61.85 0 000-18.2 115.57 115.57 0 00-4-15.5c-1.81-5.39-4.51-9-8.09-10.78v-8.08a52.69 52.69 0 01.68-7.41 20.65 20.65 0 000-7.42 34.52 34.52 0 01-.68-8.08 69 69 0 01-.67-16.85 104.77 104.77 0 012-14.82c.88-4.05 1.79-8.09 2.7-12.13a29.18 29.18 0 014-10.11c.88-3.58 1.79-6.74 2.69-9.43s1.79-5.84 2.7-9.44a26.71 26.71 0 00.67-10.1c-.46-3.14-1.13-7-2-11.46a119.25 119.25 0 00-19.54-33 97.1 97.1 0 00-31.67-24.93A212.3 212.3 0 00411 6.06Q386.77 0 358.48 1.35L347.7 0A319.85 319.85 0 00314 6.06q-13.49 3.39-22.23 10.11a70.11 70.11 0 00-14.15 14.15 86.84 86.84 0 00-9.44 16.85c-.9-.89-1.34-.68-1.34.67s-.24 2-.68 2-.9.47-1.35 1.35-.67.91-.67 0q-25.62 4-39.76 14.15a55.35 55.35 0 00-20.21 27 113.83 113.83 0 00-6.74 34.37q-.69 17.53-.67 36.39v33.69a21.8 21.8 0 001.35 6.74 28.44 28.44 0 00-10.79 12.12 44.24 44.24 0 00-4.71 16.18 76.66 76.66 0 001.39 19.51 93.81 93.81 0 006 20.89 48.3 48.3 0 006.06 12.8q3.36 4.74 7.42 10.11a51.31 51.31 0 008.08 8.76A48.14 48.14 0 00221 310q4 9.45 8.76 20.89a234.08 234.08 0 0010.1 21.56 165.15 165.15 0 0012.81 20.22 93.2 93.2 0 0015.49 16.84V442q-58 8.09-106.46 29.65t-84.21 51.24Q41.76 552.54 21.56 591T0 669.79v21.56L690 690v-20.21q-1.36-40.44-21.56-78.17zm-403-278.29q-5.4-12.79-9.44-24.93l-2.69-12.13-12.13-1.35a11.67 11.67 0 00-2.69-2 11.07 11.07 0 01-3.37-3.37c-1.35-1.79-2.7-3.58-4-5.39a22.79 22.79 0 01-3.37-8.09 8.29 8.29 0 01-2-4 21.75 21.75 0 00-1.35-4 41.37 41.37 0 01-2-6.74l21.57 4-4.09-28.33a59.46 59.46 0 01-1.34-11.45 83.82 83.82 0 00-.68-10.11 75 75 0 01-.67-9.43v-24.29c0-14.36.21-25.61.67-33.69s1.79-14.83 4-20.22 5.39-9 9.44-10.78a108.74 108.74 0 0116.84-5.39A18.94 18.94 0 00282.33 89a115.82 115.82 0 0010.11-7.42 26.68 26.68 0 006.74-8.76q2.69-5.37 5.39-6.73 1.33-6.74 4-10.11a36.91 36.91 0 017.43-6.79c3.13-2.23 7.41-3.81 12.8-4.72s12.13-2.23 20.21-4l9.44 1.35q12.12-1.34 29 1.34a247.26 247.26 0 0132.34 7.42A80 80 0 01448.1 66a59.09 59.09 0 0118.19 27v2a11.34 11.34 0 01-.67 2.7 30.2 30.2 0 01-1.35 3.36 9.15 9.15 0 00-.68 4.05 51.89 51.89 0 00-5.39 12.13 99.46 99.46 0 00-4 16.84q-1.37 8.79-2 20.22a156.6 156.6 0 00.67 24.93v13.47a28.81 28.81 0 01-.67 6.74 35.42 35.42 0 00-.68 8.09l-4 31h18.87a27.51 27.51 0 01-.67 7.41 41.44 41.44 0 00-1.35 5.39 9.48 9.48 0 01-2 4.71 42.61 42.61 0 01-2.7 8.09q-1.35 2.72-3.37 6.07a28.93 28.93 0 01-2.69 4 2.69 2.69 0 00-.68 2L438 274.92l-4 14.83q-4.05 12.12-9.44 24.25a212.53 212.53 0 01-10.11 20.22q-4.72 8.08-10.1 15.5t-12.13 10.1l-8.09 8.09V477l-36.62 34.4a3.39 3.39 0 01-4.72-.07l-34.21-34.22h.08V369.26l-8.08-6.74q-6.76-2.68-12.13-10.78c-3.6-5.39-7.41-11-11.46-16.85a117.88 117.88 0 01-11.5-21.56zM43.12 650.92v-1.35q5.39-31 26.28-60t53.91-50.54q33-21.54 75.47-37.73a355 355 0 0164.87-17.67l76.18 76.18a8 8 0 0011.32 0l75.91-75.9a312.59 312.59 0 0166.18 17.39q41.76 16.2 74.12 38.44T620.6 591q20.86 29 26.28 58.62z" data-name="Livello 1" /></g>
                        </svg>
                        <label htmlFor="number">Persone</label>
                    </div>
                    <CustomerAdder />
                </div>}
        </form>
    );
}
